<template>
  <!--
      auth:wpx
      name:HeaderWithBtn2.vue
      time:20.08.20
      desc:头部logo和打开App按钮  直播用
   -->
    <div class="logo-container">
      <img class="logo" src="../../assets/image/logo.png" alt="">
      <!-- 20211102隐藏下载App按钮 -->
      <!-- <go-app :app-url="appUrl" class="go-app">
          <van-button type="primary">下载App</van-button>
      </go-app> -->
    </div>
</template>

<script>
import GoApp from '../../components/Common/GoApp'
export default {
  name: 'HeaderWithBtnTwo',
  data () {
    return {

    }
  },
  props: {
    appUrl: {
      type: String,
      default: ''
    }
  },
  components: {
    GoApp
  },
  mounted () {
  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
  .logo-container {
    height: 24px;
    background-color: #ffffff;
    display: flex;
    justify-content: space-between;
    padding: 8px 17px 0 13px;
    margin-bottom: 8px;
    .logo {
      width: 196px;
      height: 24px;
    }
    .go-app .van-button{
      width: 72px;
      height:24px;
      padding: 0;
      font-size: 11px;
      float: right;
      background:rgba(117,58,183,1);
      border-radius:15px;
      box-shadow:0px 0px 4px 0px rgba(117,58,183,1);
      color: rgba(255,255,255,1);
      border: 0.02667rem solid rgba(117,58,183,1);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Common/HeaderWithBtnTwo.vue